export default {
  'btn:save': 'Save',
  'btn:cancel': 'Cancel',
  'btn:clear': 'Clear'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.2@ant-design-vue/es/color-picker/locale/en_US.js
// module id = null
// module chunks = 